



































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { State } from 'vuex-class'
import AppDialog from '@/components/AppDialog.vue'
import { User } from '@/interfaces/user'

@Component({
  components: {
    AppDialog
  }
})
export default class AppNav extends Vue {
  version = process.env.VUE_APP_VERSION;

  dialog = false;

  @State((state) => state.user.me) me!: User;

  signOut () {
    this.dialog = true
  }

  signOutHandler () {
    this.dialog = false
    localStorage.removeItem(process.env.VUE_APP_LOCAL_STORAGE_KEY as string)
    this.$router.replace({ name: 'SignIn' })
  }
}
